export const UmrahClass = {
  COMFORT: {
    key: 'COMFORT',
    color: 'blue',
    title: 'umrah_block.comfort',
  },
  COMFORT_PLUS: {
    key: 'COMFORT_PLUS',
    color: 'green',
    title: 'umrah_block.comfort_plus',
  },
  STANDART: {
    key: 'STANDART',
    color: 'gray',
    title: 'umrah_block.standart',
  },
  VIP: {
    key: 'VIP',
    color: 'black',
    title: 'umrah_block.vip',
  },
}

export const UmrahClassList = Object.keys(UmrahClass)?.map((key) => ({
  title: UmrahClass[key as keyof typeof UmrahClass].title,
  color: UmrahClass[key as keyof typeof UmrahClass].color,
  key: key,
}))

export type UmrahClassTypes = keyof typeof UmrahClass
